export const environment = {
  production: false,
  apiUrl: 'https://dev-tenant.travviseconnect.com/search-api',
  authApiUrl: 'https://dev-tenant.travviseconnect.com/auth-api',
  searchApiUrl: 'https://dev-tenant.travviseconnect.com/search-api/api/v1',
  tenantProvisioningApi: 'https://dev-tenant.travviseconnect.com/auth-api/api/tenant-provisioning',
  onboardingApi: 'https://dev-tenant.travviseconnect.com/auth-api/api/onboarding',
  bookingApiUrl: 'https://dev-tenant.travviseconnect.com/search-api',
  smartEngageApiUrl: 'https://dev-tenant.travviseconnect.com/smartengage-api',
  smartReachApiUrl: 'https://dev-tenant.travviseconnect.com/smartreach-api',
};